<script>
	// Stores
	import IncomingBetStore from '@/Stores/IncomingBetStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Constants
	import { CurrencyFormat, getDivisor } from '@/Services/Helpers';
	import { getBetAmount, getLiabilityForBet, isEachWayBet, getBetOddsForDisplay } from '@/Common/Bet.js';

	export let open = false;
	export let bet;

	let amount = bet.bet_amount / getDivisor();
	let element;
	let sending = false;

	$: open && element && element.focus();
	$: eachWay = bet && isEachWayBet(bet);
	$: fixedPrice = bet && bet.legs.data.first().fixed_price;
	$: winAmount = bet && fixedPrice && amount && getLiabilityForBet(bet, amount);
	$: error = amount && parseFloat(amount.toString()) > parseFloat(getBetAmount(bet).toString());

	function confirmClicked() {
		sending = true;
		IncomingBetStore.acceptBet(bet, {
			adjusted_amount: parseFloat(amount.toString()) * getDivisor()
		})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Partial Bet Failed',
					message: (e.error && e.error[0]) || 'Problem accepting bet',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
				open = false;
			});
	}

	function handleKeydown(e) {
		if (e.key === 'Enter' && document.activeElement.id === `partial-amount-${bet.id}`) {
			e.preventDefault();
			confirmClicked();
		}
	}
</script>

<svelte:window on:keydown={handleKeydown} />
{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Partial</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<p />
			<p>
				{#if eachWay}E/W{/if}
				Bet is {CurrencyFormat(bet.bet_amount)} @
				{getBetOddsForDisplay(bet)}
			</p>
			<p class="mt-4 mb-2 font-semibold">
				Enter new stake
				<span class="text-sm font-normal"
					>(To Win: {winAmount ? CurrencyFormat(parseFloat(winAmount.toString()) * getDivisor()) : 'TBA'})</span
				>
			</p>
			<input
				type="text"
				id={`partial-amount-${bet.id}`}
				bind:value={amount}
				class="form-input focus:outline-none {error ? 'border-red-500' : ''}"
				bind:this={element}
				on:focus={() => element.select()}
			/>
			{#if error}
				<div class="text-center text-red-500">New stake can't be higher than bet amount!</div>
			{/if}
			{#if eachWay}
				<div class="flex justify-center py-2 mt-1 space-x-4 font-semibold bg-gray-200">
					<div>Win: {(amount && CurrencyFormat((amount / 2) * getDivisor())) || '-'}</div>
					<div>Place: {(amount && CurrencyFormat((amount / 2) * getDivisor())) || '-'}</div>
					<div>
						Total Bet: {(parseFloat(amount.toString()) &&
							CurrencyFormat(parseFloat(amount.toString()) * getDivisor())) ||
							'-'}
					</div>
				</div>
			{/if}
			<LoadingButton
				on:click={confirmClicked}
				loading={sending}
				disabled={error}
				className="mt-4 mb-4 btn {error ? 'btn-primary-action-disabled' : 'btn-primary'}"
				>Accept [enter]
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}> Cancel [esc]</button>
		</div>
	</Modal>
{/if}
